import React, { Component } from "react"
import PropTypes from "prop-types"
import COLOR_PALETTE from "constants/color-palette"
import { PrintIcon } from "components"
import { ColumnGroup, Column } from "containers"
import { withRadium, gtmEvent } from "higher-order-components"

class VehicleServiceExport extends Component {
  static columns(date, distance, price, dealer, details) {
    return (
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div style={[styles.cell, { fontWeight: "600", letterSpacing: ".2em" }]}>{date}</div>
        <div style={styles.cell}>{distance}</div>
        <div style={styles.cell}>{price}</div>
        <div style={styles.cell}>{dealer}</div>
        <div style={styles.cell}>{details}</div>
      </div>
    )
  }

  render() {
    const {
      headerImage, vin, rego, namePlate, grade, bodyStyle, serviceHistoryData
    } = this.props

    return (
      <div style={{padding: "5em 5vw", minWidth: "842px"}}>
        <div
          style={{
            padding: "1em 0",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid " + COLOR_PALETTE.GRAY
          }}>
          <div style={{ marginRight: "1em" }}>
            <img src={headerImage} alt="Mazda" style={{ height: "44px", width: "auto" }} />
          </div>
          <div style={{ display: "flex", flexFlow: "wrap", justifyContent: "flex-end" }}>
            <span style={[styles.menuText, { borderLeft: "0" }]}>
              {namePlate} {grade} {bodyStyle}
            </span>
            <span style={styles.menuText}>VIN: {vin}</span>
            <span style={styles.menuText}>Registration: {rego}</span>
            <span style={styles.menuText}>
              {serviceHistoryData.length} service reports generated
            </span>
            <span style={styles.menuText}>
              <span
                onClick={() => window.print()}
                style={{
                  color: COLOR_PALETTE.GRAY_DARK,
                  cursor: "pointer",
                  fontWeight: "600",
                  textDecoration: "none"
                }}>
                <PrintIcon
                  style={{
                    marginRight: "0.5em",
                    width: "18px",
                    height: "16px",
                    verticalAlign: "text-bottom"
                  }} />
                Print
              </span>
            </span>
          </div>
        </div>
        <div style={{ padding: "2em 0" }}>
          <div style={styles.label}>
            {this.constructor.columns(
              "DATE",
              "ODOMETER (KM)",
              "PRICE",
              "SERVICE LOCATION",
              "SERVICE DESCRIPTION"
            )}
          </div>

          <div>
            {serviceHistoryData.map((service, i) => {
              const details = service.completedServiceItems.map((item, j) => {
                return (
                  <p key={j} style={{ marginTop: "0" }}>
                    {item.serviceDescription}
                  </p>
                )
              })

              return (
                <div
                  key={i}
                  style={{
                    borderTop: "1px solid " + COLOR_PALETTE.GRAY,
                    fontWeight: "200",
                    padding: "1em 0"
                  }}>
                  {this.constructor.columns(
                    service.serviceDates,
                    service.distance,
                    service.formattedPrice,
                    service.dealerName,
                    details
                  )}
                </div>
              )
            })}
          </div>
        </div>
      </div>
    )
  }
}

const styles = {
  label: {
    color: COLOR_PALETTE.GRAY_DARK,
    textTransform: "uppercase",
    fontSize: "81%",
    margin: "0 0 1em",
    display: "block",
    fontWeight: "600",
    letterSpacing: ".2em"
  },
  menuText: {
    fontSize: "14px",
    fontWeight: "200",
    margin: "0.25em 0 0.25em 1em",
    paddingLeft: "1em",
    borderLeft: "1px solid " + COLOR_PALETTE.GRAY
  },
  cell: {
    flex: "1 0",
    paddingRight: "0.5em"
  }
}

VehicleServiceExport.propTypes = {
  headerImage: PropTypes.string,
  vin: PropTypes.string,
  rego: PropTypes.string,
  namePlate: PropTypes.string,
  grade: PropTypes.string,
  bodyStyle: PropTypes.string,
  serviceHistoryData: PropTypes.array
}

export default withRadium(gtmEvent())(VehicleServiceExport)



// WEBPACK FOOTER //
// ./src/components/mymazda/service/export.jsx